import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { RegistrationForm } = await import('./index');
    return {
        Component: RegistrationForm,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
